import Vue from 'vue'

const directive = {
  componentUpdated (el, { value, arg, modifiers }) {
    // 获取真实的inputDOM元素
    let input = el.children[0]
    try {
      // 如果不是el输入框 那么直接返回
      if (!input) {
        return false
      }
      // 获取当前光标所在位置
      const inputSelection = input.selectionStart
      // 获取加上空格后的字符串长度
      const valueLength = input.value ? input.value.length : 0
      arg = arg || 'space'
      let ruleList = {
        nemberPoint: /[^\d.]/g, // 只能小数点和数字
        number: /[^\d]/g, // 只能数字
        numberLine: /[^\d-]/g, // 只能数字横线
        numberAndEng: /[^a-zA-Z0-9/s]/, // 只能数字和字母 下面那个可以是特殊字符
        foo: /[\u4e00-\u9fa5\s]{0,}/g, // 只能数字和字母
        space: /\s/g // 去掉所有空格
      }
      let newValue = value && Object.prototype.toString.call(value) === '[object String]' ? value.replace(ruleList[arg], '') : ''
      if (value !== newValue) {
        input.value = newValue
        if (input.value.length !== valueLength) {
          input.selectionStart = inputSelection - 1
          input.selectionEnd = inputSelection - 1
        }
        input.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'))
      }
    } catch (e) {
      console.log(e)
    }
  }
}
const install = function (Vue) {
  Vue.directive('removeSpace', directive)
}
export default install



// WEBPACK FOOTER //
// ./src/utils/removeSpace.js